import { useState } from "react";
import { HidroLayerGroup } from "./layers";
import { GeometryEditor } from "./geometryEditor";
import { Button } from "@mui/material";
import { Architecture } from "@mui/icons-material";

export interface GeometryEditorButtonProps {
  children?: React.ReactNode;
  startGeometry?: HidroLayerGroup;
  variant?: 'text' | 'outlined' | 'contained';
  onSelect?: (layers: HidroLayerGroup) => void;
}
export const GeometryEditorButton: React.FC<GeometryEditorButtonProps> = ({
  variant,
  children,
  onSelect,
  startGeometry,
}) => {
  const [open, setOpen] = useState(false);

  return <>
    <GeometryEditor
      open={open}
      initialLayers={startGeometry?.copy()}
      onClose={() => setOpen(false)}
      onFinish={(layers) => {
        if (onSelect) onSelect(layers);
        setOpen(false);
      }}
    />

    <Button
      fullWidth
      onClick={() => setOpen(true)}
      variant={variant}
      endIcon={<Architecture />}
    >
      {children}
    </Button>
  </>;
};